// LiveStreamGoalList.js
import { connect } from 'react-redux';

import getListData from '../selector/getListData.js';
import getOperationData from '../selector/getOperationData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import LiveStreamGoalList from '../component/LiveStreamGoalList.jsx';
import addModal from '../action/addModal.js';
import { karaokeType } from '../resource/goalConstants.js';

const mapStateToProps = (state, { streamId, hasToyDevice }) => {
  const status = getPrivateShowStatus(state, streamId);
  return {
    karaokeIds: getListData(
      state,
      [
        'liveStream',
        streamId,
        'karaoke',
        hasToyDevice ? karaokeType.TOY_DEVICE : karaokeType.DEFAULT,
      ],
      'itemIds'
    ),
    itemIds: getListData(
      state,
      [
        'liveStream',
        streamId,
        'goal',
        hasToyDevice ? karaokeType.TOY_DEVICE : karaokeType.DEFAULT,
      ],

      'itemIds'
    ),
    shouldDisplayKaraokeTooltip: getOperationData(state, [
      'liveStream',
      'shouldDisplayKaraokeTooltip',
    ]),
    status,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: ({ id }) =>
      dispatch(
        addModal({ id, transitionStatus: 'coming', isHigherThanAll: true })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamGoalList);
